import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useTax } from '../../hooks/CompanyConfiguration/useTax'

import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

function Taxes() {
  const { taxes } = useContext(ConfigurationContext)
  const { getAllTax, deleteTax, deleteManyTax, BulkUpload, loading, paginate } = useTax()

  const [searchQuery, setSearchQuery] = useState('')

  const filterTax = taxes ? taxes.filter((store) => store && store.name.toLowerCase().includes(searchQuery.toLowerCase())) : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const noOfPages = paginate && paginate.totalPage
  const handleChange = (event, value) => {
    setPage(value)
  }
  //console.log('SELECTED ITEM : ', selected)
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    getAllTax({ page: page, limit: 10 })
  }, [page])

  return (
    <Layout
      heading="Tax"
      url={ROUTES.ADD_TAX}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-tax/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    >
      <CustomTable>
        {filterTax.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterTax.length}
                checked={filterTax.length > 0 && selected.length === filterTax.length}
                onClick={(event) => handleSelectAllClick(event, filterTax, setSelected)}
              />,
              'name',
              'Tax Code',
              'tax value',
              'created date',
              'info',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterTax.length > 0 &&
            filterTax.map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{item.name}</TableCell>
                  <TableCell>{item.taxCode}</TableCell>
                  <TableCell>{item.taxValue + '%'}</TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                      // onClick={}
                      onClick={() => history.push(`/view-tax/${item._id}`)}
                    />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteTax({ taxId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyTax({ taxId: multipleId }, setSelected)}
      />
      {!loading && filterTax.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {loading && <Loader />}
      {!loading && !filterTax.length && <NoDataFound />}
    </Layout>
  )
}

export default Taxes
